import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { hasLocizeTranslation } from 'lib/utils/locize'
import trustCopy from 'components/pdp/desktop-trust/copy'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { SELECTOR_DATA } from '../const'
import LOCIZE_DATA from '../label-item/const'

export const SizeLabel = ({ product, t, simpleLabel, language }) => {
  const { soldOutNotifyMe, comingSoonNotifyMe } = LOCIZE_DATA
  const isComingSoon = product?.is_coming_soon
  const isSoldOut = product.stock?.is_sold_out || product.stock?.quantity < 1

  if (isSoldOut && !isComingSoon) {
    const label = isComingSoon
      ? hasLocizeTranslation(t, comingSoonNotifyMe.key, comingSoonNotifyMe.text)
      : hasLocizeTranslation(t, soldOutNotifyMe.key, soldOutNotifyMe.text)
    return <span className={clsx('sold-out', Typo.body2)}>{label}</span>
  }

  return (
    <span className={clsx('select-size', Typo.body2)}>
      {simpleLabel
        ? trustCopy(t, 'SELECT_SIZE', language)
        : hasLocizeTranslation(
            t,
            SELECTOR_DATA.selectSizeText.titleKey,
            SELECTOR_DATA.selectSizeText.default,
          )}
    </span>
  )
}

SizeLabel.defaultProps = { simpleLabel: false, language: 'en' }
SizeLabel.propTypes = {
  language: PropTypes.string,
  simpleLabel: PropTypes.bool,
  product: PropTypes.shape({
    stock: PropTypes.shape({
      quantity: PropTypes.number,
      is_sold_out: PropTypes.bool.isRequired,
    }),
    is_coming_soon: PropTypes.bool,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(SizeLabel)
